import { AvailableString, AvailableType } from '@app/entities/Delivery';

export const AvailableText = (available): string => {
  const flag1 = available >= AvailableType.PickUpTomorrow && available !== AvailableType.NoInfo;
  const flag2 = available === AvailableType.NoInfo;

  return AvailableString[available]
    ? `<div class="cart_balloon__place-pickers--in${flag1 ? '-order' : flag2 ? '-no-order' : '-stock'}">
          ${AvailableString[available]}
        </div>`
    : '';
};
